import { Observable } from 'rxjs';
import { map, scan, withLatestFrom } from 'rxjs/operators';
import { RouteMapEntry } from './models';


export function createCircularRouteAnimationParams$(
  currentRoute$: Observable<RouteMapEntry>,
  routesMap$: Observable<Map<string, RouteMapEntry>>,
  options: { duration?: string; y?: string } = {}
): Observable<{ value: number; params: { duration: string; y: string } }> {
  const duration = options.duration ?? '300ms';
  const y = options.y ?? '0px';

  return currentRoute$.pipe(
    withLatestFrom(routesMap$),
    scan(
      (acc, [route, routesMap]) => {
        const prevRouteIndex = acc.prevRouteIndex;
        const currRouteIndex = route.index;

        const lastIndex = routesMap.size - 1;

        const isForwardWrap = prevRouteIndex === lastIndex && currRouteIndex === 0;
        const isBackwardWrap = prevRouteIndex === 0 && currRouteIndex === lastIndex;

        const direction = isForwardWrap
          ? 'forward'
          : isBackwardWrap
          ? 'backward'
          : currRouteIndex > prevRouteIndex
          ? 'forward'
          : 'backward';

        const virtualIndex = direction === 'forward'
          ? acc.virtualIndex + 1
          : acc.virtualIndex - 1;

        return {
          value: virtualIndex,
          params: { duration, y },
          prevRouteIndex: currRouteIndex,
          virtualIndex
        };
      },
      {
        value: 0,
        params: { duration, y },
        prevRouteIndex: 0,
        virtualIndex: 0
      }
    ),
    map(({ value, params }) => ({ value, params }))
  );
}
